import { Grid, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useMemo } from 'react'
import { useApiQuery } from 'Hooks/App/useApiQuery'
import { SectionLoader } from 'Components/Section'
import { KoreanSchoolContentForm } from '../Organisms'
import {
  normalizeKoreanSchoolContentDetail,
  normalizeKoreanSchoolContentsList,
} from 'Entities/koreanSchoolContent'
import { useKoreanLanguageConfig } from '../Hooks'

export default () => {
  const { koreanLanguageId } = useParams<{ koreanLanguageId: string }>()
  const { schoolContentQueryType } = useKoreanLanguageConfig()

  const detailQuery = useApiQuery<unknown>({
    key: `koreanSchoolContent-one-${koreanLanguageId}`,
    url: `/api/org/korean-school-contents/${koreanLanguageId}`,
    options: { enabled: !!koreanLanguageId, retry: false },
  })

  const useListFallback =
    !!koreanLanguageId && detailQuery.isError && !detailQuery.isFetching

  const listQuery = useApiQuery<unknown>({
    key: 'koreanSchoolContents',
    url: '/api/org/korean-school-contents',
    params: {
      type: schoolContentQueryType,
    },
    options: { enabled: useListFallback },
  })

  const data = useMemo(() => {
    const fromDetail = normalizeKoreanSchoolContentDetail(detailQuery.data)
    if (fromDetail) {
      return fromDetail
    }
    if (useListFallback && listQuery.data !== undefined) {
      const list = normalizeKoreanSchoolContentsList(listQuery.data)
      return list.find(item => String(item.id) === koreanLanguageId)
    }
    return undefined
  }, [detailQuery.data, koreanLanguageId, listQuery.data, useListFallback])

  const isLoading = detailQuery.isLoading || (useListFallback && listQuery.isLoading)
  const isFetching = detailQuery.isFetching || listQuery.isFetching

  const showNotFound = !!koreanLanguageId && !isLoading && !isFetching && !data

  return (
    <SectionLoader isLoading={isLoading} isFetching={isFetching}>
      {data ? (
        <Grid container rowSpacing={4}>
          <Grid item xs={12}>
            <KoreanSchoolContentForm key={data.id} data={data} />
          </Grid>
        </Grid>
      ) : null}
      {showNotFound ? (
        <Typography color='text.secondary'>Запись не найдена или недоступна.</Typography>
      ) : null}
    </SectionLoader>
  )
}
